function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M254.49,57.48H217V47a8.5,8.5,0,0,0-17,0V57.48H100V47a8.5,8.5,0,0,0-17,0V57.48H45.51A16.53,16.53,0,0,0,29,74V245a16.54,16.54,0,0,0,16.51,16.52h209A16.54,16.54,0,0,0,271,245V74A16.53,16.53,0,0,0,254.49,57.48ZM83,74.48V83a8.5,8.5,0,1,0,17,0V74.48H200V83a8.5,8.5,0,1,0,17,0V74.48h37v36H46v-36Zm-37,170v-117H254v117Z"
});

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  points: "150.09 177.99 149.91 177.99 136.67 154.99 121.91 154.99 143.43 190.33 143.43 217.99 156.44 217.99 156.44 190.33 178.09 154.99 163.19 154.99 150.09 177.99"
});

var SvgCalendarYear = function SvgCalendarYear(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 300",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarYear, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar_year.73bf5ca6.svg";
export { ForwardRef as ReactComponent };